// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightsholder-maintenance-banking-tab h5 {
  padding-bottom: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/PayeeBankingInfo/index.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;AAAJ","sourcesContent":[".rightsholder-maintenance-banking-tab {\n  h5 {\n    padding-bottom: 2.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
